export interface ISiteNavigationInstanceState {
  definitionDetails: { [key: string]: any }
  details: { [key: string]: any }
}

export const initialSiteNavigationInstanceState: ISiteNavigationInstanceState = {
  definitionDetails: {},
  details: {},
}

export interface IManageSiteNavigationSlice {
  navigationsById: { [navigationId: string]: ISiteNavigationInstanceState }
}
